import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";

import SectionContent from "../../../components/sectionContent/sectionContent";
import Reports from "../../../pages/easymerch/reports/reports";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from '../../../types/interfaces';

const ReportApp = () => {

  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  return (
    <div className="App">
      <Sidebar />

      <SectionContent section="Easy Merch" title="Типы отчетов">
        <div className="content__main">
          <div className="btns">
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/outlets" className="tab">
              <div className="buttons__btn">Торговые точки</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/report" className="tab">
              <div className="buttons__btn --active">Типы отчетов</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/users" className="tab">
              <div className="buttons__btn">Физ. лица</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/service-types" className="tab">
              <div className="buttons__btn">Типы обслуживания</div>
            </Link>}
            {(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && <Link to="/easymerch/integration-errors" className="tab">
              <div className="buttons__btn">Ошибки интеграции</div>
            </Link>}
          </div>
          <Reports />
        </div>
      </SectionContent>
    </div>
  );
};

export default ReportApp;
